interface CurrencySymbol {
    locales: string | string[] | undefined;
    currency: string;
}

const currencySymbol = ({
    locales,
    currency,
}: CurrencySymbol): string | undefined => {
    const formatter = new Intl.NumberFormat(locales, {
        style: "currency",
        currency,
    });

    let symbol;
    formatter.formatToParts(0).forEach(({ type, value }) => {
        if (type === "currency") {
            symbol = value;
        }
    });

    return symbol;
};

export { currencySymbol };